module.exports = __webpack_public_path__ + "img/question_left.c660cae2.png";